import wallet from './wallet'

export default {
  wallet
}
